import React, { useState }      from 'react';
import { useSwipeable }         from 'react-swipeable';
import ArchiveIcon              from '@mui/icons-material/Archive';
import {
    List,
    ListItem,
    ListItemText,
    Avatar,
    Divider,
    Box,
    Typography,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
} from '@mui/material';

const SwipeableListItem = ({ contact, onContactClick, onArchive, userRoles }) => {
    
    const [swipeDistance, setSwipeDistance  ] = useState(0);
    const [openDialog,    setOpenDialog     ] = useState(false);

    const swipeHandlers = useSwipeable({
        onSwiping: (eventData) => {
            setSwipeDistance(Math.max(-50, eventData.deltaX));
        },
        onSwiped: () => {
            if (swipeDistance <= -30) {
                setSwipeDistance(-50);
            } else {
                setSwipeDistance(0);
            }
        },
        trackMouse: true,
    });

    const handleDeleteClick = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmArchive = () => {
        onArchive(contact);
        setOpenDialog(false);
    };

    return (
        <Box {...swipeHandlers} sx={{ position: 'relative' }}>
            {/* Box rosso per il pulsante di eliminazione, visibile solo quando swipeDistance è negativo */}
            {swipeDistance < 0 && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        width: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#263F78',
                        borderRadius: '10px',
                        zIndex: 0,
                    }}
                >
                    <IconButton
                        onClick={handleDeleteClick}
                        sx={{
                            color: 'white',
                        }}
                    >
                        <ArchiveIcon />
                    </IconButton>
                </Box>
            )}

            <ListItem
                button
                onClick={() => onContactClick(contact)}
                sx={{
                    transform: `translateX(${swipeDistance}px)`,
                    transition: swipeDistance === -50 ? 'transform 0.3s ease' : 'none',
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                <Avatar sx={{ bgcolor: '#FDA03D', mr: 2 }}>
                    {contact?.ragioneSociale?.charAt(0)}
                </Avatar>
                <ListItemText
                    primary={userRoles === 'CLIENTE' ? `RMA #${contact?.idReso}` : `${contact?.ragioneSociale || "Undefined"} (#${contact?.idReso})`}
                    secondary={
                        <Typography
                            variant="body2"
                            noWrap
                            sx={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                maxWidth: '200px',
                            }}
                        >
                            {contact?.ultimoMessaggio}
                        </Typography>
                    }
                />
            </ListItem>
            <Divider />

            {/* Dialog di conferma per l'eliminazione */}
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ color: '#263F78', fontWeight: 'bold', textAlign: 'center'}}>{"Conferma Archiviazione"}</DialogTitle>
                    <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
                        <DialogContentText id="alert-dialog-description" sx={{ textAlign: 'center' }}>
                            Sei sicuro di voler archiviare questa chat?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button 
                    onClick={handleCloseDialog}
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#b0bec5", 
                        color: "#ffffff", 
                        "&:hover": {
                            transform: "scale(1.05)",
                            backgroundColor: "#90a4ae",
                        },
                    }}
                    >
                        Annulla
                    </Button>
                    <Button 
                    onClick={handleConfirmArchive} 
                    variant="contained"
                        sx={{
                            borderRadius: '10px',
                            width: '10em',
                            backgroundColor: "#213d72", 
                            color: "#ffffff", 
                            "&:hover": {
                                backgroundColor: "#1a315b", 
                                transform: "scale(1.05)",
                            },
                        }}
                        autoFocus
                    >
                        Archivia
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

const ContactsList = ({ contacts, onContactClick, onArchive }) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userRoles = user.roles[0];

    return (
        <Box
            sx={{
                width: '300px',
                height: 'calc(100vh - 110px)',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
            }}
        >
            <List>
                {contacts.map((contact) => (
                    <SwipeableListItem
                        key={contact.id}
                        contact={contact}
                        onContactClick={onContactClick}
                        onArchive={onArchive}
                        userRoles={userRoles}
                    />
                ))}
            </List>
        </Box>
    );
};

export default ContactsList;